exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".xm-home[data-v-6cfb9f8a]{padding-right:40px;padding-left:40px;position:relative;padding-top:48px;padding-bottom:48px}.title[data-v-6cfb9f8a]{margin-bottom:30px}.home-space[data-v-6cfb9f8a]{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.account-tooltip-popper[data-v-6cfb9f8a]{max-width:none;width:430px}.text[data-v-6cfb9f8a]{margin-right:8px;margin-left:8px;vertical-align:middle}.jump-text[data-v-6cfb9f8a]{position:absolute;top:3px;left:140px}", ""]);

// exports
